import { MAX_STAGE_HEIGHT } from './constants';

const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '24px',
  },
  stage: {
    width: '100%',
    height: `${MAX_STAGE_HEIGHT}px`,
    backgroundColor: '#fafafa',
    border: '1px solid #f2f2f2',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circularProgress: {
    marginLeft: theme.spacing(1),
    color: 'var(--jmi-blue)',
  },
  loading: {
    display: 'flex',
    flexDirection: 'row',
  },
});

export default styles;
